import { breakpoints } from '@/themes/themeOverrides/Breakpoints';

export const customDialogRightStyles = {
    popupWrapper: {
        padding: '32px 56px !important',
        [`@media (max-width: ${breakpoints.values.md}px)`]: {
            padding: '32px 20px !important',
        },
        '& .popup-box--header': {
            padding: '0px',
        },
    },
    popupBoxHeader: {
        padding: '24px 56px 24px',
        [`@media (max-width: ${breakpoints.values.md}px)`]: {
            padding: '24px 20px 24px',
        },
    },
};
